import type { TFunction } from 'i18next';

const KNOWN_FAILURES = new Set([
  'NOT_AUTHORISED',
  'RECIPIENT_UNKNOWN',
  'TIMED_OUT',
  'CONNECTION_CLOSED',
  'SEND_FAILED',
  'WORKER_LOST',
  'OUTCOME_AMBIGUOUS',
  'IDENTITY_SWITCHED',
  'RECIPIENT_CHANGED',
  'UNRECORDED',
]);

/** A failure code in the reader's language; a code the product has no wording for is named, never hidden. */
export function failureReasonLabel(t: TFunction, code: string): string {
  return KNOWN_FAILURES.has(code)
    ? t(`reports.crm.failureReason.${code}`)
    : t('reports.crm.failureReason.other', { code });
}
